export const shouldHighlightNavItem = ({
  isNavigationCollapsed,
  isActive,
  isSubItemActive,
}: {
  isNavigationCollapsed: boolean;
  isActive: boolean;
  isSubItemActive: boolean;
}) => {
  let shouldHighlight = false;

  // Case 1: Navigation is collapsed and either the item or its sub-item is active
  if (isNavigationCollapsed && (isActive || isSubItemActive)) {
    shouldHighlight = true;
  }

  // Case 2: Navigation is expanded, the item is active, and no sub-item is active
  if (!isNavigationCollapsed && isActive && !isSubItemActive) {
    shouldHighlight = true;
  }

  return shouldHighlight;
};
